import { useEffect, useRef } from 'react';

/**
 * Intervalo con la higiene de polling del repo (BarraPage + SidebarBest):
 * - dispara al montar y luego cada `ms`,
 * - en segundo plano no gasta peticiones (visibilityState),
 * - al volver a la pestaña o enfocar la ventana refresca al instante.
 * `callback` se lee de un ref: el intervalo no se recrea en cada render.
 */
export default function useSmackPolling(callback, ms, enabled = true) {
  const cbRef = useRef(callback);
  cbRef.current = callback;

  useEffect(() => {
    if (!enabled) return undefined;

    const tick = () => cbRef.current?.();

    tick();
    const interval = setInterval(() => {
      if (document.visibilityState !== 'visible') return;
      tick();
    }, ms);

    const onFocus = () => tick();
    const onVisibility = () => {
      if (document.visibilityState === 'visible') tick();
    };
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [ms, enabled]);
}
